// extracted by mini-css-extract-plugin
export var header = "F_q";
export var headerWhite = "F_bJ";
export var variant1 = "F_bD";
export var variant2 = "F_bF";
export var variant3 = "F_bG";
export var variant4 = "F_bK";
export var variant5 = "F_bL";
export var variant6 = "F_bM";